import React from "react";

//controls
import AvatarCircle from "./AvatarCircle";
import TitleText from "./TitleText";
//icon
import { Img1, Img2, Img3 } from "../../svg/reclamo";

import { contentTitlesClaim } from "../../utils/constanst";
import { styleText } from "../../svg/reclamo/index";

const TextProgressBarReclamo = ({ indexProgress }) => {
  const widthIcon = 30;
  const width = 100 * indexProgress;

  return (
    <div className="sg-iconbar_nr">
      {contentTitlesClaim.map((title, index) => (
        <TitleText
          key={index}
          index={index}
          indexProgress={indexProgress}
          width={50}
        >
          {title}
        </TitleText>
      ))}
    </div>
  );
};

export default TextProgressBarReclamo;
